<template>
  <v-dialog v-model="dialog" persistent width="880">
    <v-card>
      <ModalHeader
        title="Add stock to"
        icon="mdi-package-variant"
        @close="dialog = false"
      />
      <v-card-text class="pa-4">
        <v-text-field
          outlined
          dense
          label="search"
          prepend-icon="mdi-magnify"
          v-model="search"
        ></v-text-field>
        <v-data-table
          :items="filtered_items"
          :headers="headers"
          :search="search"
        >
          <template v-slot:item.action="{ item }">
            <v-btn
              @click="merge(item)"
              small
              color="primary"
              :loading="loading"
              :disabled="loading"
              >Add Stock</v-btn
            >
          </template>
          <template v-slot:item.is_deleted="{ item }">
            <span v-if="item.is_deleted" class="red--text">Deleted</span>
            <span v-else class="green--text">Active</span>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="$emit('close')"> Close</v-btn>
        <v-spacer></v-spacer>
        <p class="caption grey--text">mergeItemModal.vue</p>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex/dist/vuex.common.js";
export default {
  props: ["item"],
  data() {
    return {
      search: "",
      dialog: true,
      loading: false,
      headers: [
        { text: "", value: "action" },
        { text: "ID", value: "id" },
        { text: "Item Name", value: "item_name" },
        { text: "Batch", value: "import_batch.batch_description" },
        { text: "Selling Price", value: "selling_price" },
        { text: "Quantity", value: "quantity" },
        { text: "Status", value: "is_deleted" },
        { text: "Branch", value: "branch.branch_name" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      all_items: "item/all_items",
      user: "auth/user",
    }),
    filtered_items() {
      var filtered1 = this.all_items.filter((i) => {
        return i.is_deleted == 0 && i.branch_id == this.item.to_branch_id;
      });
      return filtered1;
    },
  },
  methods: {
    ...mapActions({
      add_item_transfer: "item_transfer/add_item_transfer",
    }),
    submit() {
      return;
    },
    async merge(item) {
      if (
        await this.$confirm({
          title: "Merge Item",
          message: "Are you sure you want to proceed?",
          color: "orange",
          icon: "mdi-alert",
        })
      ) {
        this.loading = true;
        try {
          // Pass to_item_id so controller knows which destination item to add lots to
          const transferPayload = {
            ...this.item,
            to_item_id: item.id,
          };
          await this.add_item_transfer(transferPayload);
          // Refresh items list to reflect updated quantities
          await this.$store.dispatch("item/get_items");
          // Let the parent transfer modal show the success notification and
          // close everything (avoids a duplicate alert and prevents a second
          // submission from the still-open transfer form). (JMB-17)
          this.$emit("merged");
        } catch (err) {
          this.$alert({
            title: "Error",
            message:
              "Error: " + (err.response?.data?.error || err.message || err),
            color: "error",
            icon: "mdi-alert-circle",
          });
        } finally {
          this.loading = false;
        }
      }
    },
  },
  created() {
    this.search = this.item.item_name;
  },
};
</script>

<style lang="scss" scoped></style>
